// extracted by mini-css-extract-plugin
module.exports = {"logo":"AppHeader_logo__2Pi4b","connect":"AppHeader_connect__2ztwB","toggle":"AppHeader_toggle__o-FiZ","load":"AppHeader_load__hCsga"};